// src/App.js
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import ScrollToTop from './components/includes/ScrollToTop';
import CorporateTraining from './pages/CorporateTraining';
import Navbar from './components/includes/Navbar';
import MiniNavbar from './components/includes/MiniNavbar';
import Home from './pages/Home';
import Courses from './pages/Courses';
import About from './pages/AboutUs';
import Contact from './pages/ContactUs';
import Project from './pages/ProjectsPage';
import CourseDetailPage from './pages/CourseDetailPage';
import Footer from './components/includes/Footer';
import PageWrapper from './components/includes/PageWrapper';
import EnrollmentFormPopup from './components/includes/EnrollmentFormPopup';
import ProductPage from './pages/ProductPage';
import RegisterPopupForm from './components/projects/RegisterPopupForm';
import EnrollWithPopup from './enroll/EnrollWithPopup';
import FeedeskPage from './pages/FeedeskPage';
import FeedeskHero from './components/feedesk/FeedeskHero';
import FeedeskPricingContent from './components/feedesk/FeedeskPricingContent';
import FeedeskRegisterForm from './components/feedesk/FeedeskRegisterForm';

// AppContent must be INSIDE <Router> so useLocation works
function AppContent() {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isRegisterOpen, setIsRegisterOpen] = useState(false);
  const location = useLocation();
  const isFeedeskPage = location.pathname === '/feedesk';

  // Standalone enroll page — no nav, no footer
  if (location.pathname === '/enroll-me') {
    return <EnrollWithPopup />;
  }

  return (
    <PageWrapper>
      <ScrollToTop />
      <MiniNavbar />
      <Navbar setIsRegisterOpen={setIsRegisterOpen} setIsPopupVisible={setIsPopupVisible} />

      <div className="main-content">
        <Routes>
          <Route path="/" element={<Home setIsPopupVisible={setIsPopupVisible} />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/courses/:courseId" element={<CourseDetailPage setIsPopupVisible={setIsPopupVisible} />} />
          <Route path="/corporate-training" element={<CorporateTraining setIsPopupVisible={setIsPopupVisible} />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/products" element={<ProductPage setIsRegisterOpen={setIsRegisterOpen} setIsPopupVisible={setIsPopupVisible} />} />
          <Route path="/feedesk" element={<FeedeskPage setIsRegisterOpen={setIsRegisterOpen} setIsPopupVisible={setIsPopupVisible} />} />
          <Route path="/feedesk-hero" element={<FeedeskHero />} />
          <Route path="/feedesk-pricing" element={<FeedeskPricingContent />} />
          <Route path="/sparklio" element={<ProductPage setIsRegisterOpen={setIsRegisterOpen} setIsPopupVisible={setIsPopupVisible} />} />

        </Routes>
      </div>

      <Footer />
      {/* Global popup */}
      <EnrollmentFormPopup isVisible={isPopupVisible} setIsVisible={setIsPopupVisible} />
      {isFeedeskPage ? (
        <FeedeskRegisterForm isOpen={isRegisterOpen} onClose={() => setIsRegisterOpen(false)} />
      ) : (
        <RegisterPopupForm isOpen={isRegisterOpen} onClose={() => setIsRegisterOpen(false)} />
      )}
    </PageWrapper>
  );
}

// App just provides the Router wrapper
function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;



// // src/App.js
// import React, { useState } from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import ScrollToTop from './components/includes/ScrollToTop';
// import CorporateTraining from './pages/CorporateTraining';
// import Navbar from './components/includes/Navbar';
// import MiniNavbar from './components/includes/MiniNavbar';
// import Home from './pages/Home';
// import Courses from './pages/Courses';
// import About from './pages/AboutUs';
// import Contact from './pages/ContactUs';
// import Project from './pages/ProjectsPage';
// import CourseDetailPage from './pages/CourseDetailPage';
// import Footer from './components/includes/Footer';
// import PageWrapper from './components/includes/PageWrapper'; 
// import EnrollmentFormPopup from './components/includes/EnrollmentFormPopup';
// import ProductPage from './pages/ProductPage';
// import RegisterPopupForm from './components/projects/RegisterPopupForm';

// function App() {
//   const [isPopupVisible, setIsPopupVisible] = useState(false);
//     const [isRegisterOpen, setIsRegisterOpen] = useState(false);

//   return (
//     <Router>
//       <PageWrapper>
//         <ScrollToTop />
//          <MiniNavbar />
//         <Navbar setIsRegisterOpen={setIsRegisterOpen} setIsPopupVisible={setIsPopupVisible} />
//         <div className="main-content">
//           <Routes >
//             <Route path="/" element={<Home setIsPopupVisible={setIsPopupVisible} />} />
//             <Route path="/courses" element={<Courses />} />
//             <Route path="/courses/:courseId" element={<CourseDetailPage setIsPopupVisible={setIsPopupVisible}/>} />
//             <Route path="/corporate-training" element={<CorporateTraining setIsPopupVisible={setIsPopupVisible}/>} />
//             <Route path="/about" element={<About />} />
//             <Route path="/contact" element={<Contact />} />
//             <Route path="/products" element={<ProductPage setIsRegisterOpen={setIsRegisterOpen} setIsPopupVisible={setIsPopupVisible}  />} />
//           </Routes>
//         </div>
//         <Footer />
//         {/* Global popup */}
//         <EnrollmentFormPopup isVisible={isPopupVisible} setIsVisible={setIsPopupVisible} />
//         <RegisterPopupForm isOpen={isRegisterOpen} onClose={() => setIsRegisterOpen(false)}/>
//       </PageWrapper>
//     </Router>
//   );
// }

// export default App;
